import i18n from 'i18next'
import { createRoute, redirect } from '@tanstack/react-router'

import { appRoute } from '@/app'
import { appState } from '@/appState'

export const rootRoute = createRoute({
    getParentRoute: () => appRoute,
    path: '/$tenantShortId',
    beforeLoad: async ({ location }): Promise<void> => {
        const [, tenantShortId] = location.pathname.split('/')

        if (tenantShortId !== appState.tenant?.shortId) {
            try {
                appState.cache.setTenantShortId(tenantShortId)
                // -- we ignore abortController here as stopping loading during caching is not good so
                // worst case in dev this might load twice
                await appState.loadTenant({ tenantShortId })
            } catch (error: any) {
                throw redirect({
                    replace: true,
                    to: '/error',
                    search: {
                        code: 'noTenantAccess',
                        message:
                            error?.message?.indexOf('missing.') === 0
                                ? // @ts-expect-error its fine
                                  i18n.t(`tenant.error.${error.message}`)
                                : i18n.t('tenant.error.unknown'),
                    },
                })
            }
        }
    },
    shouldReload: false,
    staleTime: Infinity,
})
